export enum Resource {
    CENTERS = 'centers',
    CHILDREN = 'children',
    EMPLOYEES = 'employees',
    LAWS = 'laws',
    LESSONS = 'lessons',
    SUBJECTS = 'subjects',
    SCHEDULE = 'schedule',
    SPECIAL_SERVICES = 'special-services',
    REPORTS = 'reports',
    PROFILE = 'profile'
}
